import NProgress from 'nprogress'; // progress bar
import router from './router';
import store from './store';
import 'nprogress/nprogress.css'; // progress bar style
import { getAccessToken, getAccountIndex, getLoginTypeId } from './utils/auth'; // get token from cookie
import getPageTitle from './utils/get-page-title.js';

NProgress.configure({ showSpinner: false }); // NProgress Configuration

const whiteList = ['/']; // no redirect whitelist
const whiteList1 = ['/verify'];
let expDays;
router.beforeEach(async (to, from, next) => {
  // start progress bar
  NProgress.start();

  // set page title
  document.title = getPageTitle(to.meta.title);

  // determine whether the user has logged in
  const hasToken = getLoginTypeId();
  if(to.path === '/verify')   {
        next();
  } else if (hasToken) {    
    expDays = store.getters.passExpDays;
    if ((expDays >= 90  || expDays < 0)  && to.path !== '/changePassword') {
      next({ path: '/changePassword' });
    }
    else{
    if (to.path === '/') {
      
      const hasGetUserInfo = store.getters.name;      
      if (!hasGetUserInfo) {
        const accIndex = getAccountIndex() || 0;
        await store.dispatch('user/getInfo', accIndex);
      }
      
      // if is logged in, redirect to the home page
      const code = store.getters.activeModelCode;
      if (code === 'VIRTUAL_ACCOUNT') {
        next({ path: '/collect/transactions' });
      } else if (code === 'ONDEMAND_SETTLEMENT') {
        next({ path: '/ondemand-settlement/statements' });
      } else if (code === 'UPI') {
        next({ path: '/upi/transactions' });
      }

      NProgress.done();
    } else {
      if(to.path === '/verify')
      {
        next('/');
      }
      const hasGetUserInfo = store.getters.name;
      if (to.path === '/logins') {
        const hasGetUserInfo = store.getters.name;
        
       if (!hasGetUserInfo) {
        const accIndex = getAccountIndex() || 0;
        await store.dispatch('user/getInfo', accIndex);
        }
        const code = store.getters.activeModelCode;
        if (code === 'VIRTUAL_ACCOUNT') {
          next({ path: '/collect/transactions' });
        } else if (code === 'ONDEMAND_SETTLEMENT') {
          next({ path: '/ondemand-settlement/statements' });
        } else if (code === 'UPI') {
          next({ path: '/upi/transactions' });
        }else if (code === 'CASH_COLLECT') {
          next({ path: '/cashcollect/transactions' });
        }
        else if (code === 'BBPS_BOU') {
          next({ path: '/bbps/statements' });
        }
        NProgress.done();
      }
      if (hasGetUserInfo) {

        if (to.meta.productCode === 'VIRTUAL_ACCOUNT' || to.meta.productCode === 'ONDEMAND_SETTLEMENT' || to.meta.productCode == 'UPI' || to.meta.productCode == 'CASH_COLLECT' || to.meta.productCode == 'BBPS_BOU') {
          if (store.getters.productList.find(({ productCode }) => productCode === to.meta.productCode)) {
            if (store.getters.activeModelCode === to.meta.productCode) {
              next();
            } else {
              
              await store.dispatch('user/changeModel', to.meta.productCode);
              next();
            }
          } else {
            next({ path: '/error' });
          }
        } else {
          next();
        }
      } else {
        try {
          // get user info
          const accIndex = getAccountIndex() || 0;
          await store.dispatch('user/getInfo', accIndex);
          expDays = store.getters.passExpDays;
          if ((expDays >= 90  || expDays < 0)  && to.path !== '/changePassword') {
            next({ path: '/changePassword' });
          }
          if (to.meta.productCode === 'VIRTUAL_ACCOUNT' || to.meta.productCode === 'ONDEMAND_SETTLEMENT' || to.meta.productCode == 'UPI' || to.meta.productCode == 'CASH_COLLECT' || to.meta.productCode == 'BBPS_BOU') {
            if (store.getters.productList.find(({ productCode }) => productCode === to.meta.productCode)) {
              if (store.getters.activeModelCode === to.meta.productCode) {
                next();
              } else {
                
                await store.dispatch('user/changeModel', to.meta.productCode);
                next();
              }
            } else {
              next({ path: '/error', query: { message: 'Access Denied' } });
            }
          } else {
            next();
          }

        } catch (error) {
          // remove token and go to login page to re-login
          await store.dispatch('user/resetToken');
          // Message.error(error || 'Has Error');
          
          next(`/?redirect=${to.path}`);
          NProgress.done();
        }
      }
    }
  }
  }
  
  else if (whiteList.indexOf(to.path) !== -1) {
    // in the free login whitelist, go directly
    next();
  }
  else {
    // other pages that do not have permission to access are redirected to the login page.
  
    next(`/?redirect=${to.path}`);
    NProgress.done();
  }
});

router.afterEach(() => {
  // finish progress bar
  NProgress.done();
});
